'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { fetchPublishedCollections } from '../clients/ecosystemClient';
import * as StorefrontCollection from '../constants/StorefrontCollection';
import * as StorefrontCollectionSlug from '../constants/StorefrontCollectionSlug';
import { maybeEarlyRequest } from '../utils/earlyRequests';
import * as ActionTypes from './ActionTypes';
import CollectionListing from 'ecosystem-marketplace-core/records/CollectionListing';
import { getIsLegacyCollectionListing } from '../utils/collections'; // TODO deprecate StorefrontCollection/StorefrontCollectionSlug

const LEGACY_COLLECTIONS = [StorefrontCollection.POPULAR, StorefrontCollection.NEW, StorefrontCollection.FREE, StorefrontCollection.HOMEMADE].map(collectionIdOrTuple => {
  let collectionId;
  let collectionProps = {};

  if (Array.isArray(collectionIdOrTuple)) {
    [collectionId, collectionProps] = collectionIdOrTuple;
  } else {
    collectionId = collectionIdOrTuple;
  }

  return Object.assign({
    id: collectionId,
    slug: StorefrontCollectionSlug[collectionId]
  }, collectionProps);
});
export const getCollections = isAdminPreview => dispatch => {
  const collectionsRegex = new RegExp(/collections\/(\d*)/);
  const previewCollectionId = isAdminPreview && collectionsRegex.test(window.location.href) && window.location.href.match(collectionsRegex)[1];
  dispatch({
    type: ActionTypes.COLLECTIONS_REQUESTED
  });
  const request = maybeEarlyRequest('self-serve-collections', () => fetchPublishedCollections(isAdminPreview));
  return request.then(({
    collections
  }) => {
    const mergedCollectionListings = [...LEGACY_COLLECTIONS, ...collections].map((_ref) => {
      let {
        id: collectionId,
        publishedListing,
        draftListing
      } = _ref,
          rest = _objectWithoutPropertiesLoose(_ref, ["id", "publishedListing", "draftListing"]);

      const listing = isAdminPreview && previewCollectionId === `${collectionId}` ? draftListing : publishedListing;

      if (!listing && !getIsLegacyCollectionListing(CollectionListing.from({
        collectionId
      }))) {
        return null;
      }

      return Object.assign({
        collectionId
      }, rest, {}, listing || {});
    }).filter(mergedCollection => !!mergedCollection);
    dispatch({
      type: ActionTypes.COLLECTIONS_RECEIVED,
      payload: mergedCollectionListings
    });
    return mergedCollectionListings;
  }).catch(error => {
    dispatch({
      type: ActionTypes.COLLECTIONS_FAILED,
      payload: error
    });
    throw error;
  });
};